import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { PRESET_AVATARS } from "../lib/gameLogic";
import { Check } from "lucide-react";
import { sfx } from "../lib/sounds";

export default function AvatarPicker({ open, onOpenChange, current, onSelect }) {
  const [selected, setSelected] = useState(current);

  React.useEffect(() => {
    if (open) setSelected(current);
  }, [open, current]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#0A0D14] border border-blue-500/40 rounded-none text-white max-w-2xl"
        data-testid="avatar-picker-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-tight text-2xl text-glow-blue">
            Choose Your Vessel
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-2">
          {PRESET_AVATARS.map((a) => {
            const active = a.id === selected;
            return (
              <button
                key={a.id}
                onClick={() => {
                  sfx.click();
                  setSelected(a.id);
                }}
                className={`relative border-2 transition group ${
                  active
                    ? "border-purple-400 ring-glow-purple"
                    : "border-white/10 hover:border-blue-400"
                }`}
                data-testid={`avatar-option-${a.id}`}
              >
                <img
                  src={a.url}
                  alt={a.name}
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black to-transparent p-2 text-center">
                  <div className="font-display uppercase tracking-wider text-xs">
                    {a.name}
                  </div>
                </div>
                {active && (
                  <div className="absolute top-1 right-1 bg-purple-500 p-0.5">
                    <Check className="h-3 w-3 text-white" />
                  </div>
                )}
              </button>
            );
          })}
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="rounded-none border-white/20 bg-transparent text-slate-300 hover:bg-white/5"
            data-testid="avatar-picker-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onSelect(selected);
              onOpenChange(false);
            }}
            className="rounded-none bg-purple-600 hover:bg-purple-500"
            data-testid="avatar-picker-confirm"
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
